export const CopyrightText = (): JSX.Element => {
  return <>©{new Date().getFullYear()} Sony Global Education, Inc.</>
}
